import { endpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-d.lpgcylindertrackingpp.alzp.tgscloud.net',
    providers: endpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'en-GB',
  allowedLanguage: ['fr-FR', 'en-GB'],
  appName: 'LPG Cylinder Tracking | Backoffice',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle'],
  appIcons: ['upload', 'excel'],
};
